import { useEffect, useState } from 'react';

export const CalmBreathingAnimation = ({
  totalTime,
  isAnimating,
  onFinish,
  showTime = true,
}: {
  totalTime: number;
  showTime?: boolean;
  isAnimating: boolean;
  onFinish: () => void;
}) => {
  const [scale1, setScale1] = useState(1);
  const [scale2, setScale2] = useState(1);
  const [minutes, setMinutes] = useState(Math.floor(totalTime / 60));
  const [seconds, setSeconds] = useState(Math.floor(totalTime % 60));
  const [interval1, setInterval1] = useState<NodeJS.Timeout | null>(null);
  const [interval2, setInterval2] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!isAnimating) return;

    const timer = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds > 0) {
          return prevSeconds - 1;
        } else if (minutes > 0) {
          setMinutes((prevMinutes) => prevMinutes - 1);
          return 59;
        } else {
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [minutes, seconds, isAnimating]);

  useEffect(() => {
    if (!isAnimating) return;

    const animateScale1 = () => {
      setScale1(1.6);
      setTimeout(() => setScale1(1), 3000);
    };

    const animateScale2 = () => {
      setScale2(1.2);
      setTimeout(() => setScale2(1), 3000);
    };

    const interval1 = setInterval(animateScale1, 6000);
    setInterval1(interval1);

    const interval2 = setInterval(animateScale2, 6000);
    setInterval2(interval2);

    animateScale1();
    animateScale2();

    return () => {
      clearInterval(interval1);
      clearInterval(interval2);
    };
  }, [isAnimating]);

  useEffect(() => {
    if (minutes === 0 && seconds === 0) {
      if (interval1) {
        clearInterval(interval1);
        setScale1(1);
      }

      if (interval2) {
        clearInterval(interval2);
        setScale2(1);
      }

      setTimeout(() => onFinish(), 1500);
    }
  }, [interval1, interval2, minutes, onFinish, seconds]);

  return (
    <div className="relative flex items-center justify-center">
      <div className="relative flex h-[319px] w-[319px] items-center justify-center">
        <div
          className="absolute h-full w-full rounded-full"
          style={{
            backgroundImage: 'radial-gradient(50% 50% at 50% 50%, #F7E1CF 0%, #CEE0F3 100%)',
          }}></div>
        <div
          className="absolute h-[75%] w-[75%] rounded-full"
          style={{
            backgroundImage: 'radial-gradient(50% 50% at 50% 50%, #CEE0F4 0%, #F5E6EC 100%)',
            transform: `scale(${scale2})`,
            transition: 'transform 3s ease-in-out',
          }}></div>
        <div
          className="absolute flex h-[50%] w-[50%] items-center justify-center rounded-full"
          style={{
            backgroundImage: 'radial-gradient(50% 50% at 50% 50%, #D0E2F5 0%, #FFF 100%)',
            transform: `scale(${scale1})`,
            transition: 'transform 3s ease-in-out',
          }}></div>
        <div className="absolute items-center justify-center">
          {showTime ? (
            <span className="flex items-center gap-1 text-2xl font-bold">
              <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20.5 4.79L15.9 0.93L14.61 2.46L19.21 6.32L20.5 4.79ZM6.38 2.46L5.1 0.93L0.5 4.78L1.79 6.31L6.38 2.46ZM11 7.07H9.5V13.07L14.25 15.92L15 14.69L11 12.32V7.07ZM10.5 3.07C5.53 3.07 1.5 7.1 1.5 12.07C1.5 17.04 5.52 21.07 10.5 21.07C15.47 21.07 19.5 17.04 19.5 12.07C19.5 7.1 15.47 3.07 10.5 3.07ZM10.5 19.07C6.63 19.07 3.5 15.94 3.5 12.07C3.5 8.2 6.63 5.07 10.5 5.07C14.37 5.07 17.5 8.2 17.5 12.07C17.5 15.94 14.37 19.07 10.5 19.07Z"
                  fill="#438FE8"
                />
              </svg>
              {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
};
